import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import RecentUpdatesNotificationCard from '../RecentUpdatesNotificationCard';

const STATUS_NEW = 'New';
const STATUS_EDITED = 'Edited';

/**
 * @typedef {object} CheckpointNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {CheckpointNotificationProps} props
 */
const CheckpointNotification = props => {
  const { notification } = props;

  const status = notification.IsEdited ? STATUS_EDITED : STATUS_NEW;

  const redirectUrl = pageUrlService.getViewCheckpointPageUrl(
    notification.OrgUnitId,
    notification.AppraisalId,
    notification.CheckPoint.Id
  );

  return (
    <RecentUpdatesNotificationCard
      name={notification.Name}
      label={`${status} Check Point from ${notification.CheckPoint.DataCollectionDate} is available.`}
      notificationDaysAgo={notification.NotificationDaysAgo}
      redirectUrl={redirectUrl}
    />
  );
};

export default CheckpointNotification;
